import React, { Component } from 'react';
import { Row, Col, Card, CardHeader, CardBody, Button } from "shards-react";
import Firebase from 'firebase';
import { Link } from 'react-router-dom';
import { StaticRouter } from 'react-router';
import { set } from 'react-ga';
import { Satellite } from '@material-ui/icons';
import exportFromJSON from 'export-from-json'


class ProductsIndex extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            orders:[],
            categories:[],
            selectedProduct:[],
            isProductSelected:false,
            clientUUID:'-ohlnfwebk',
            city:'',
            invoices:[]
        };
    }

    getInvoice(){

    }
    renderJunior(){
        let paymentArray = [];
        for(let i =0; i< this.state.orders.length; i++){
            if(this.state.orders[i].typeAge === "2,3,4,5 (Junioren)"){
                let newItem = {type: "Junior",naam: this.state.orders[i].firstname + ' '+this.state.orders[i].lastname, adres: this.state.orders[i].adres +' , '+this.state.orders[i].city, telefoonnummers: "Naam:"+ this.state.orders[i].emergencyName + ' Nummer: ' +this.state.orders[i].emergencyPhone , geboortedatum: this.state.orders[i].birthdate,bijzonderheden:  this.state.orders[i].specialties}
            
            paymentArray.push(newItem)
            }
        }

        return paymentArray;
    }
    renderSenior(){
        let paymentArray = [];
        for(let i =0; i< this.state.orders.length; i++){
            if(this.state.orders[i].typeAge === "6,7,8 (Senioren)"){

            let newItem = {type: "Senior",naam: this.state.orders[i].firstname + ' '+this.state.orders[i].lastname, adres: this.state.orders[i].adres +' , '+this.state.orders[i].city, telefoonnummers: "Naam:"+ this.state.orders[i].emergencyName + ' Nummer: ' +this.state.orders[i].emergencyPhone , geboortedatum: this.state.orders[i].birthdate,bijzonderheden:  this.state.orders[i].specialties}
            
            paymentArray.push(newItem)
            }

        }

        return paymentArray;
    }

    exportJuniors(){

        const data = this.renderJunior();

    const fileName = 'download'
    const exportType = 'xls'

    exportFromJSON({ data: JSON.stringify(data) , fileName: 'Inschrijvingen junioren', exportType: exportFromJSON.types.xls })
    }

    exportSeniors(){

        const data = this.renderSenior();

    const fileName = 'download'
    const exportType = 'xls'

    exportFromJSON({ data: JSON.stringify(data) , fileName: 'Inschrijvingen senioren', exportType: exportFromJSON.types.xls })
    }


    getOrders(){
    
        let ref = Firebase.database().ref('/orders/');
        
        ref.on('value' , snapshot => {
            this.setState({
                orders:[]
            })
            snapshot.forEach((childSnap) => {
            let state = childSnap.val();



                Firebase.storage().ref(state.filePath).getDownloadURL().then((url) => {
    
                    let newInvoice ={key: state.key, url: url};
                    
                    this.setState(prevState => ({
                        invoices: [...prevState.invoices, newInvoice]
                    }))
    
                  
                  })

                this.setState(prevState => ({
                    orders: [...prevState.orders, state],
                  
                }))  



    
        })

    
    
    
    })
    }



    componentDidMount() {

       this.getOrders();
            
   
      

        
    }

    changeActive(product){

        for(let k = 0; k <this.state.products.length; k++){
                this.state.products[k].checked = false;
                this.state.products[k].active = 'not-active';
                
                this.setState({
                    products: this.state.products,
                    selectedProduct: [],
                    isProductSelected:false
                })
               
             
        }

        for(let i = 0; i < this.state.products.length; i++){
            if(this.state.products[i].id === product.id && this.state.products[i].checked === false){
                this.state.products[i].active = 'active';
                this.state.products[i].checked = true;
                this.setState({
                    products: this.state.products,
                    selectedProduct: this.state.products[i],
                    isProductSelected:true
                })
            }else if(this.state.products[i].id === product.id && this.state.products[i].checked === true){
                this.state.products[i].active = 'not-active';
                this.state.products[i].checked = false;
                this.setState({
                    products: this.state.products,
                })
            }
        }


      
     
        
       /* this.setState({
            products:this.state.products.filter(item => item.id !== product.id),
        })

        let newProduct = {id:product.id,name:product.name, status:product.status,stock: product.stock,category:product.category,active:'active'}
        this.setState(prevState =>({
            products: [...prevState.products,newProduct]
        }))*/
    }


    deleteProduct(){
        Firebase.database().ref('/cities/'+this.state.city+'/shops/'+Firebase.auth().currentUser.uid+'/products/'+this.state.selectedProduct.id).remove();
        this.setState({
            products:this.state.products.filter(item => item.id !== this.state.selectedProduct.id),
            selectedProduct:[],
            isProductSelected:false
        });

        
    }

    

    render() {
        return (
            <div>
            <Row className="col-sm-12">
    
                <Col sm={12} className="products-actions">
               
                    <div>
                    <Button onClick={()=>this.exportJuniors()}>Exporteer junioren</Button> <Button onClick={()=>this.exportSeniors()}>Exporteer senioren</Button> 
                    </div>
                   {/*} <Link className="align-button-right" to={{pathname: `/producten/toevoegen`}} >Product toevoegen</Link>*/}
                </Col>
       
                <Col sm={12} className="products-table">
                
            <table>
                <tr>
                
                    <th>Orderid</th>
                    <th>Naam</th>
                    <th>Status</th>
                    <th>Aantal</th>
                    <th>Factuur</th>
                    <th>Actie</th>
                </tr>

                {this.state.orders.map((order)=>(
                    <tr className={order.active}>
                         <td>{order.orderId}</td>
                    <td>{order.lastname}</td>
                    <td>{order.status}</td>
                    <td>{order.amountKids}</td>
                    <td>
                    {this.state.invoices.filter(invoice => order.key == invoice.key).map((invoice)=>(
                                        <a href={invoice.url} target="_blank">Factuur</a>
                                    ))}
                    </td>
                    <td><Link to={{pathname: `/producten/aanpassen`,state: {data: order}}} >Bekijk</Link></td>
                </tr>
                ))}
                
            
            </table>
</Col>
   
            </Row>
            </div>



        );
    }
};

export default ProductsIndex;